import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "step-container" }
const _hoisted_2 = { class: "file-input-box" }
const _hoisted_3 = { class: "custom-file-input" }
const _hoisted_4 = { class: "filename" }
const _hoisted_5 = { class: "step-container" }
const _hoisted_6 = { class: "options-container" }
const _hoisted_7 = {
  key: 0,
  class: "option suffix-input-container"
}
const _hoisted_8 = { class: "sample-result-box" }
const _hoisted_9 = {
  key: 1,
  class: "option conversion-input-container"
}
const _hoisted_10 = { class: "conversion-input-box" }
const _hoisted_11 = { for: "conversionType" }
const _hoisted_12 = { for: "conversionType" }
const _hoisted_13 = { class: "conversion-input-sample" }
const _hoisted_14 = {
  key: 0,
  class: "conversion-input-sample-proper"
}
const _hoisted_15 = {
  key: 1,
  class: "conversion-input-sample-list"
}
const _hoisted_16 = {
  key: 2,
  class: "option no-options-container"
}
const _hoisted_17 = { class: "step-container" }
const _hoisted_18 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepNumber = _resolveComponent("StepNumber")!
  const _component_LoaderComp = _resolveComponent("LoaderComp")!
  const _component_ErrorModal = _resolveComponent("ErrorModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      class: "file-upload-container",
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_StepNumber, { number: 3 }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("Select your file")
          ])),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, [
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Choose your file", -1)),
            _createElementVNode("input", {
              type: "file",
              max: "1",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
              id: "fileInput"
            }, null, 32)
          ]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.filename), 1)
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "line" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_StepNumber, { number: 4 }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode("Select available customizations")
          ])),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.sourceFormat == 'json' && _ctx.targetFormat == 'xml')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[13] || (_cache[13] = _createElementVNode("span", null, "Suffix for list items: ", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "suffix",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.suffix) = $event)),
                  maxlength: "10"
                }, null, 512), [
                  [_vModelText, _ctx.suffix]
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[10] || (_cache[10] = _createElementVNode("pre", null, "//Suffix for lists", -1)),
                  _createElementVNode("pre", null, "<user" + _toDisplayString(_ctx.suffix) + ">", 1),
                  _cache[11] || (_cache[11] = _createElementVNode("pre", null, "  <user/>", -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("pre", null, "  <user/>...", -1)),
                  _createElementVNode("pre", null, "<user" + _toDisplayString(_ctx.suffix) + ">...", 1)
                ])
              ]))
            : (_ctx.sourceFormat == 'xlsx' && _ctx.targetFormat == 'xml')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", null, "Conversion type format", -1)),
                    _createElementVNode("label", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "conversionType",
                        value: "PROPER",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.conversionType) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.conversionType]
                      ]),
                      _cache[14] || (_cache[14] = _createElementVNode("span", null, "Default", -1))
                    ]),
                    _createElementVNode("label", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "conversionType",
                        value: "LIST",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.conversionType) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.conversionType]
                      ]),
                      _cache[15] || (_cache[15] = _createElementVNode("span", null, "List style", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    (_ctx.conversionType == 'PROPER')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[17] || (_cache[17] = [
                          _createElementVNode("pre", null, "<Sheet>", -1),
                          _createElementVNode("pre", null, "    <Row>", -1),
                          _createElementVNode("pre", null, "        <Cell Column=\"0\">UserName</Cell>", -1),
                          _createElementVNode("pre", null, "        <Cell Column=\"1\">Details</Cell>", -1),
                          _createElementVNode("pre", null, "    </Row>...", -1),
                          _createElementVNode("pre", null, "</Sheet>", -1)
                        ])))
                      : (_ctx.conversionType == 'LIST')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[18] || (_cache[18] = [
                            _createElementVNode("pre", null, "<Records>", -1),
                            _createElementVNode("pre", null, "    <Record>", -1),
                            _createElementVNode("pre", null, "        <UserName>John Doe</Cell>", -1),
                            _createElementVNode("pre", null, "        <Details>Just a chill guy</Cell>", -1),
                            _createElementVNode("pre", null, "    </Record>...", -1),
                            _createElementVNode("pre", null, "</Records>", -1)
                          ])))
                        : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[19] || (_cache[19] = [
                  _createElementVNode("span", null, "No available options for selected formats.", -1)
                ])))
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "line" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_StepNumber, { number: 5 }, {
          default: _withCtx(() => _cache[21] || (_cache[21] = [
            _createTextVNode("Verify and Convert")
          ])),
          _: 1
        }),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearInputs && _ctx.clearInputs(...args)))
          }, "Clear"),
          _cache[22] || (_cache[22] = _createElementVNode("button", { type: "submit" }, "Convert", -1))
        ])
      ])
    ], 32),
    _createVNode(_component_LoaderComp, { "is-visible": _ctx.isLoading }, null, 8, ["is-visible"]),
    (_ctx.isError)
      ? (_openBlock(), _createBlock(_component_ErrorModal, {
          key: 0,
          closeErrorModal: _ctx.closeErrorModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.errMsg), 1)
          ]),
          _: 1
        }, 8, ["closeErrorModal"]))
      : _createCommentVNode("", true)
  ], 64))
}